import { routing } from '@repo/web-chrome/i18n/routing';
import { createNavigation } from 'next-intl/navigation';

const navigation = createNavigation(routing);

export const LocaleLink = navigation.Link;
export const localeRedirect = navigation.redirect;
export const useLocalePathname = navigation.usePathname;
export const useLocaleRouter = navigation.useRouter;
export const getLocalePathname = navigation.getPathname;
